import { Controller } from "@hotwired/stimulus"
import { JavascriptAPI } from "lib/javascript_api";

export default class extends Controller {
  static values = {
    messageUuid: String,
    responseType: String,
    createdAt: String,
    rank: Number,
    requestType: String,
  };

  connect() {
    this.dispatchComplete();
  }

  dispatchComplete() {
    const domId = `message-${this.messageUuidValue}_card`;
    const messageElement = document.getElementById(domId);
    if (messageElement) {
      this.dispatchInternalEvent(messageElement);
    }
    this.dispatchExternalEvent();
  }

  dispatchInternalEvent(messageElement) {
    this.dispatch("complete", {
      detail: {
        content: {
          uuid: this.messageUuidValue,
          responseType: this.responseTypeValue,
          element: messageElement
        }
      }
    });
  }

  dispatchExternalEvent() {
    // Don't dispatch events for unrouted responses (e.g. contact info, feedback comment)
    if (this.responseTypeValue == null || this.responseTypeValue.length <= 0) {
      return
    }

    // Don't dispatch events for contact info requests and feedback follow ups
    if (this.requestTypeValue?.length > 0) {
      return
    }

    JavascriptAPI.v0.broadcastResponseComplete({
      responseType: this.responseTypeValue,
      createdAt: this.createdAtValue,
      interactionCount: this.rankValue
    });
  }
}